module.exports = __webpack_public_path__ + "media/offers/offer-pion-black@2x-67eddb34.png";